<template>
    <div class="sale-analysis">
        <OptionCard
                :info="{ title: '销售分析', desc: `${pageParams.startDateTime}~${pageParams.endDateTime}`, label: pageParams.dateLabel}"
                :body-style="{padding: '0px 20px 20px'}"
                :actions="['refresh']"
                key="sale-analysis"
                @refresh="refresh">
            <OptionCard :info="{ title: '销售排名'}" :actions="[]" :areaLevel="2" noBorder :body-style="{padding: 0}">
                <el-row type="flex" >
                    <el-col style="width: 250px;" v-loading="loading.line">
                        <div class="sale-analysis-aside">
                            <div class="sale-analysis-aside__rank">
                                <span class="title">{{ rankingData.mainSellerCategory | defaultShow }}</span>
                                <span class="bold">{{ rankingData.mainSellerRank || '-' }}</span>
                                <span>较昨日：{{ rankingData.mainSellerRankThan | defaultShow }}</span>
                                <span>较上周同日：{{ rankingData.lastWeekMainSellerRankThan | defaultShow }}</span>
                            </div>
                            <div class="sale-analysis-aside__rank">
                                <span class="title">{{ rankingData.sellerCategory | defaultShow }}</span>
                                <span class="bold">{{ rankingData.sellerRank || '-' }}</span>
                                <span>较昨日：{{ rankingData.sellerRankThan | defaultShow }}</span>
                                <span>较上周同日：{{ rankingData.lastWeekSellerRankThan | defaultShow }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col v-loading="loading.line">
                        <ve-line height="250px" :data-empty="chartRankingData.empty" :data="chartRankingData.data" :settings="chartRankingData.settings" :extend="chartRankingData.options"></ve-line>
                    </el-col>
                </el-row>
            </OptionCard>
            <OptionCard :info="{ title: '24小时订单量分布'}" :actions="[]" :areaLevel="2" noBorder :body-style="{padding: 0}" style="margin-top: 20px;">
                <el-row v-loading="loading.hours">
                    <ve-histogram height="250px" :legend-visible="false" :data-empty="chartHourData.empty" :data="chartHourData.data" :settings="chartHourData.settings" :extend="chartHourData.options"></ve-histogram>
                </el-row>
            </OptionCard>
            <OptionCard :info="{ title: '订单站点分布与订单量累计分布'}" :actions="[]" :areaLevel="2" noBorder :body-style="{padding: '0px 20px'}" style="margin-top: 10px;">
                <gj-select slot="action" v-model="groupType" :options="GROUP_OPTIONS" @change="getOrderDistributed" :clearable="false"></gj-select>
                <div slot="info" class="order-area-slot">
                    <span>(订单量：<em style="font-style: normal;">{{ orderTotal | defaultShow }}</em></span>
                    <span>购买地区：<em style="font-style: normal;">{{ buyerArea | defaultShow }}</em>)</span>
                </div>
                <el-row type="flex" :gutter="10">
                    <el-col :span="13" v-loading="loading.histogram" >
                        <div class="sale-analysis-border sale-analysis-margin">
                            <ve-histogram height="292px" :data-empty="chartOrderData.empty" :data="chartOrderData.data" :settings="chartOrderData.settings" :extend="chartOrderData.options"></ve-histogram>
                        </div>
                    </el-col>
                    <el-col :span="11" >
                        <div class="sale-analysis-order sale-analysis-border sale-analysis-margin">
                            <el-row type="flex" justify="space-between" class="sale-analysis-order__item" v-for="order in orderData" :key="order.area" >
                                <el-col :span="3" style="font-size: 13px;">{{ order.area }}</el-col>
                                <el-col :span="12" :offset="3">
                                    <el-progress :text-inside="true" :stroke-width="15" :percentage="Number(order.per || 0)"></el-progress>
                                </el-col>
                                <el-col :span="3" :offset="3" style="text-align: right; font-size: 13px;">{{ order.orders | defaultShow }}</el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <OptionCard :info="{ title: '退货原因分析'}" :areaLevel="2" :actions="[]" :body-style="{padding: 0}" style="padding-left: 20px;">
                            <gj-link @click="handleNavigateReturn('/sale/customerReturn')" slot="action" style="font-size: 14px">退货报告</gj-link>
                            <el-row v-loading="loading.histogram">
                                <ve-ring height="300px" :legend-visible="false" :data-empty="chartReturnReasonData.empty"  :data="chartReturnReasonData.data" :settings="chartReturnReasonData.settings" :extend="chartReturnReasonData.options" @click="$router.push({ path: '/sale/replacementOrder' })"></ve-ring>
                            </el-row>
                        </OptionCard>
                    </el-col>
                    <el-col :span="12">
                        <OptionCard :info="{ title: '换货原因分析'}" :areaLevel="2" :actions="[]" :body-style="{padding: 0}" style="padding-left: 20px;">
                            <gj-link @click="handleNavigateReturn('/sale/replacementOrder')" slot="action" style="font-size: 14px">换货报告</gj-link>
                            <el-row v-loading="loading.histogram">
                                <ve-ring height="300px" :legend-visible="false" :data-empty="chartReplacementReasonData.empty" :data="chartReplacementReasonData.data" :settings="chartReplacementReasonData.settings" :extend="chartReplacementReasonData.options"></ve-ring>
                            </el-row>
                        </OptionCard>
                    </el-col>
                </el-row>
            </OptionCard>
        </OptionCard>
    </div>
</template>

<script>
    import {
        DATA_CHARTS,
        DATE_ENUMS, DEFAULT_CHARTS_DATA
    } from "modules/statistics/asin-361-analysis/config";
    import { GROUP_OPTIONS } from "@/utils/options";
    import {
        postReturnReasonAnalysis,
        postReplacementReasonAnalysis,
        getOrderDistributed,
        getHoursDistributed,
        getSellerRankLine
    } from "@/api/statistics";
    import {
        generatorSalesRankingChartData
    } from "modules/statistics/asin-361-analysis/config";

    import OptionCard from 'components/option-card/option-card'
    import _ from "lodash";

    export default {
        name: "statistics-sale-analysis",
        inject: ['getPageParams', 'generatorPageParams'],
        data () {
          return {
              DATA_CHARTS,
              DATE_ENUMS,
              GROUP_OPTIONS,
              groupType: 'AREA',
              rankingData: {},
              returnReasonData: {}, // 退货原因
              replacementReasonData: {}, // 换货原因
              orderTotal: 0, // 订单总量
              buyerArea: 0, // 购买地区数
              list: [],
              orderData: [], // 订单柱状图
              hourData: [], // 区域数据
              loading: {
                  hours: false,
                  histogram: false,
                  line: false,
                  pieOne: false,
                  pieTwo: false
              },
              noData: {
                  hours: false,
                  histogram: false,
                  line: false,
                  pieOne: false,
                  pieTwo: false
              }
          }
        },
        components: {
            OptionCard
        },
        created () {
            this.postReplacementReasonAnalysis()
            this.postReturnReasonAnalysis()
            this.getHoursDistributed()
            this.getOrderDistributed()
            this.getSellerRankLine()
        },
        computed: {
            pageParams () {
                return this.getPageParams()
            },
            chartRankingData ({ rankingData = {} }) {
                let statisticsData = rankingData.statisticsData || [];
                let thanData = rankingData.thanData || [];
                let columns = ['dateLine', 'mainSellerRank', 'sellerRank'];
                const maxRank = this._.max(statisticsData.map(item => {
                    return item.mainSellerRank > item.sellerRank ? item.mainSellerRank : item.sellerRank;
                })) + 10;
                let rows = statisticsData.map((v, i) => ({
                    dateLine: v.dateLine,
                    mainSellerRank: v.mainSellerRank ? v.mainSellerRank : maxRank,
                    sellerRank: v.sellerRank ? v.sellerRank : maxRank,
                }))

                return {
                    data: {
                        columns,
                        rows
                    },
                    settings: {
                        labelMap: {
                            dateLine: '日期',
                            mainSellerRank: '大类排名',
                            sellerRank: '小类排名'
                        }
                    },
                    options: generatorSalesRankingChartData(statisticsData, thanData, maxRank),
                    empty: !rows.length
                }
            },
            chartHourData ({ hourData = [] }) {
                let columns = ['hours', 'orders']
                let rows = hourData.map(({
                    hours = '',
                    orders = 0,
                }) => ({
                    hours,
                    orders
                }))

                return {
                    data: {
                        rows,
                        columns
                    },
                    settings: {
                        labelMap: {
                            hours: '小时',
                            orders: '订单量'
                        },
                    },
                    options: {
                        color: ['#1F6EEF'],
                        grid: {
                            top: '35px',
                            left: '2%',
                            bottom: '5%',
                            right: 0
                        },
                        series: {
                            barMaxWidth: 25
                        }
                    },
                    empty: !rows.length
                }
            },
            chartOrderData ({ orderData = [], orderTotal = 0 }) {
                if (!orderData.length) return DEFAULT_CHARTS_DATA
                let reasonPercentList = orderData.map(v => (v.per ? parseFloat(v.per) : 0))
                let columns = ['area', 'orders', 'per']
                let rows = orderData.map(({
                    area = '',
                    orders = 0,
                    per = 0
                }, i) => ({
                    area,
                    orders,
                    per: this.reducePercent(reasonPercentList, i)
                }))

                const leftMaxY = Math.max(...rows.map(v => v.orders))
                const rightMaxY = 1

                return {
                    data: {
                        rows,
                        columns
                    },
                    settings: {
                        labelMap: {
                            area: '区域',
                            orders: '订单量',
                            per: '订单累计分布'
                        },
                        axisSite: {
                            right: [
                                'per'
                            ]
                        },
                        yAxisName: [
                            "订单量",
                            "订单累计分布"
                        ],
                        yAxisType: [
                            'normal',
                            "percent"
                        ],
                        showLine: [
                            'per'
                        ]
                    },
                    options: {
                        color: ['#1F6EEF', '#FA7A7A'],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'cross',
                                crossStyle: {
                                    color: '#999'
                                }
                            },
                        },
                        legend: {
                            data: ['订单量', '订单累计分布'],
                            top: '10px',
                            itemGap: 10,
                            icon: "rect",
                            itemWidth: 15,
                            itemHeight: 3,
                            textStyle: {
                                color: '#888',
                                padding: [2, 0, 0, 0],
                            }
                        },
                        xAxis: [
                            {
                                type: 'category',
                                axisPointer: {
                                    type: 'shadow'
                                },
                                axisLine: {
                                    show: false,
                                    lineStyle: {
                                        color: "#e5e9f2"
                                    }
                                },
                                axisLabel: {
                                    margin: 10,
                                    color: "#32393d"
                                },
                            }
                        ],
                        // yAxis: [
                        //     {
                        //         type: 'value',
                        //         name: '订单量',
                        //         nameTextStyle:{
                        //             color: "#32393d"
                        //         },
                        //         axisLabel: {
                        //             margin: 10,
                        //             color: "#32393d",
                        //             formatter: '{value}'
                        //         },
                        //         axisLine: {
                        //             show: false,
                        //             lineStyle: {
                        //                 color: "#e5e9f2"
                        //             }
                        //         },
                        //         min: 0,
                        //         max: leftMaxY,
                        //         splitNumber: 5,
                        //         interval: Math.ceil(leftMaxY / 5),
                        //     },
                        //     {
                        //         type: 'value',
                        //         name: '订单累计分布',
                        //         nameTextStyle:{
                        //             color: "#32393d"
                        //         },
                        //         axisLabel: {
                        //             margin: 10,
                        //             color: "#32393d",
                        //             formatter: '{value} %'
                        //         },
                        //         axisLine: {
                        //             show: false,
                        //             lineStyle: {
                        //                 color: "#e5e9f2"
                        //             }
                        //         },
                        //         min: 0,
                        //         max: 1,
                        //         splitNumber: 5,
                        //         interval: Math.ceil(rightMaxY / 5),
                        //     }
                        // ],
                        yAxis (item) {
                            item[0].splitNumber = 5
                            item[0].interval = leftMaxY / 5
                            item[0].min = 0
                            item[0].max = leftMaxY
                            item[1].splitNumber = 5
                            item[1].interval = rightMaxY / 5
                            item[1].min = 0
                            item[1].max = rightMaxY
                            return item
                        },
                        grid: {
                            left: '2%',
                            top: '45px',
                            bottom: '5%',
                            right: '2%'
                        },
                        series: {
                            barMaxWidth: 35
                        }
                    },
                    empty: !rows.length
                }
            },
            chartReturnReasonData ({ returnReasonData }) {
                let { reasonOrderQuantityList = [], totalOrderQuantity = 0 } = returnReasonData
                if (!reasonOrderQuantityList.length) return DEFAULT_CHARTS_DATA
                let columns = ['原因', '订单量']
                let rows = reasonOrderQuantityList.map(v => ({
                    '原因': v.reason,
                    '订单量': v.orderQuantity
                }))

                return {
                    data: {
                        columns,
                        rows
                    },
                    settings: {

                    },
                    options: {
                        series: {
                            center: ['50%', '50%'],//设置饼图位置
                            radius: ['30%', '50%'],
                            label: {
                                formatter: `{b}: {c}, {d}%`
                            },
                        }
                    },
                    empty: !rows.length
                }
            },
            chartReplacementReasonData ({ replacementReasonData }) {
                let { reasonOrderQuantityList = [], totalOrderQuantity = 0 } = replacementReasonData
                if (!reasonOrderQuantityList.length) return DEFAULT_CHARTS_DATA
                let columns = ['原因', '订单量']
                let rows = reasonOrderQuantityList.map(v => ({
                    '原因': v.reason,
                    '订单量': v.orderQuantity
                }))

                return {
                    data: {
                        columns,
                        rows
                    },
                    settings: {
                        labelLine: {
                            show: true
                        }
                    },
                    options: {
                        series: {
                            center: ['50%', '50%'],//设置饼图位置
                            radius: ['30%', '50%'],
                            label: {
                                formatter: `{b}: {c}, {d}%`
                            },
                        }
                    },
                    empty: !rows.length
                }
            }
        },
        methods: {
            /**
             * 跳转退货报告
             */
            handleNavigateReturn (path) {
                if (!path) return
                const params = this.pageParams
                let query = {
                    marketIds: params.countryData.marketIds,
                    countryCodes: params.countryData.countryIds,
                    asinCode: params.asinCode,
                    startDateTime: params.startDateTime,
                    endDateTime: params.endDateTime,
                }
                this.$router.push({ path, query: { param: JSON.stringify(query)} })
            },
            /**
             * 累加订单量
             */
            reducePercent (reasonPercentList = [], i) {
                let sliceList = reasonPercentList.slice(0, i + 1)
                return reasonPercentList.length - 1 === i ? 1 : sliceList.length <= 1 ? sliceList[i] / 100 : sliceList.reduce((prev, next) => this.$NP.plus(prev, next)) / 100
            },
            /**
             * 获取销售排名数据
             */
            getSellerRankLine () {
                let params = this.generatorPageParams(this.getPageParams())
                this.loading.line = true
                getSellerRankLine(params).then(res => {
                    this.rankingData = Object.assign({}, this.rankingData, res)
                }).complete(() => this.loading.line = false)
            },
            /**
             * 获取订单站点分布与订单累计分布
             */
            getOrderDistributed () {
                let params = this.generatorPageParams(this.pageParams)
                params.groupType = this.groupType
                this.loading.histogram = true
                getOrderDistributed(params).then(({
                      orderTotal = 0,
                      buyerArea = 0,
                      list = []
                }) => {
                    this.orderTotal = orderTotal
                    this.buyerArea = buyerArea
                    this.orderData = list
                }).complete(() =>  this.loading.histogram = false)
            },
            /**
             * 获取单日24小时订单分布
             */
            getHoursDistributed () {
                let params = this.generatorPageParams(this.pageParams)
                this.loading.hours = true
                getHoursDistributed(params).then((res = []) => {
                    this.hourData = res
                }).complete(() => this.loading.hours = false)
            },
            /**
             * 获取退货原因数据
             */
            postReturnReasonAnalysis () {
                let params = this.generatorPageParams(this.pageParams)
                this.loading.pieOne = true
                postReturnReasonAnalysis(params).then(res => {
                    this.returnReasonData = Object.assign({}, this.returnReasonData, res)
                }).complete(() => this.loading.pieOne = false)
            },
            /**
             * 获取换货原因数据
             */
            postReplacementReasonAnalysis () {
                let params = this.generatorPageParams(this.pageParams)
                this.loading.pieTwo = true
                postReplacementReasonAnalysis(params).then(res => {
                    this.replacementReasonData = Object.assign({}, this.replacementReasonData, res)
                }).complete(() => this.loading.pieTwo = false)
            },
            /**
             * 刷新区域数据
             */
            refresh () {
                this.postReplacementReasonAnalysis()
                this.postReturnReasonAnalysis()
                this.getHoursDistributed()
                this.getOrderDistributed()
                this.getSellerRankLine()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .sale-analysis {
        &-margin {
            margin: 20px 0 15px;
        }

        &-border {
            border-radius: 2px;
            border: 1px solid #EBEEF5;
            overflow: hidden;
        }

        &-tooltip {
            background: rgba(255, 255, 255, 0.5);
        }

        &-aside {
            color: #333333;
            text-align: center;
            padding-top: 25px;
            &__title {
                font-size: 14px;
                font-weight: bold;
                line-height: 20px;
                margin-bottom: 15px;
            }

            &__rank {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 12px;

                &:nth-last-of-type(1) {
                    margin-bottom: 0;
                }



                & > span {
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16px;
                    margin-top: 5px;
                    color: #666666;

                    &.bold {
                        font-weight: bold;
                        line-height: 31px;
                        font-size: 24px;
                    }

                    &.title {
                        color: #333333;
                    }
                }


            }
        }

        &-order {
            padding: 10px;
            height: 292px;
            overflow: auto;
            box-sizing: border-box;
            &__item {
                margin-bottom: 20px;
            }
        }

        .order-area-slot {
            display: inline-block;
            font-weight: normal;
            font-size: 12px;
            color: #666;
            margin-left: 8px;

            & > span {
                margin-right: 8px;
            }
        }


    }
</style>
